module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copyrighth"
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("Copyright © 1993 by Jack Womack")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Any members of educational institutions wishing to photocopy part or all of the work for classroom use, or publishers who would like to obtain permission to include the work in an anthology, should send their inquiries to Grove/Atlantic, Inc., 841 Broadway, New York, NY 10003.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_c('em', [_vm._v("First published in Great Britain in 1993 by HarperCollins Publishers"), _c('br'), _vm._v("Published simultaneously in Canada"), _c('br'), _vm._v("Printed in the United States of America")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Womack, Jack.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("Random acts of senseless violence / Jack Womack.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright2"
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("eBook ISBN-13: 978-1-5558-4761-6")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1"
  }, [_vm._v("1. New York (N.Y.)—Fiction. I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright1a"
  }, [_vm._v("PS3573.O575R36   1995   813′.54—dc20       95-38204")]), _vm._v(" "), _c('p', {
    staticClass: "copyright"
  }, [_vm._v("Grove Press"), _c('br'), _vm._v("841 Broadway"), _c('br'), _vm._v("New York, NY 10003")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-662c7b76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copyright.vue
// module id = 72
// module chunks = 0